// extracted by mini-css-extract-plugin
export default {"surveyReviewContainer":"AuditingReview_surveyReviewContainer__MJYq4","submitButton":"AuditingReview_submitButton__55Ya2","title":"AuditingReview_title__rQgKW"};